module.exports = __webpack_public_path__ + "img/gem_broken.f76dfc53.png";